import { createActionCreator } from '@pressreader/appstore';
import { IIssueCalendarInfo, IIssueInfo, IIssueInfoPageKey } from '@pressreader/content-types';

import { MODULE_NAME } from '../../../constants';

const prefix = `${MODULE_NAME}/issues/issueinfo/`;

export const loadIssueInfoBegan = createActionCreator<{
    cid: string;

    /** If null, latest issue is loaded. */
    issueDate?: Date;

    languageCode?: string;
}>(`${prefix}load-issue-info-began`);

export const loadIssueInfoDone = createActionCreator<{
    latest: boolean;
    issueInfo: IIssueInfo;
    languageCode?: string;
}>(`${prefix}load-issue-info-done`);

export const loadIssueInfoFailed = createActionCreator<{
    cid: string;
    issueDate?: Date;
    languageCode?: string;
}>(`${prefix}load-issue-info-failed`);

export const loadIssuePageKeysDone = createActionCreator<{
    cidDateKey: string;
    pageKeys: { [pageNumber: number]: IIssueInfoPageKey };
}>(`${prefix}load-issue-page-keys-done`);

export const loadIssueCalendarInfoAction = createActionCreator<{
    cid: string;
}>(`${prefix}load-issue-calendar-info`);

export const loadIssueCalendarInfoBegan = createActionCreator<{
    cid: string;
}>(`${prefix}load-issue-calendar-info-began`);

export const loadIssueCalendarInfoDone = createActionCreator<{
    cid: string;

    calendar: IIssueCalendarInfo;
}>(`${prefix}load-issue-calendar-info-done`);

export const loadIssueCalendarInfoFailed = createActionCreator<{
    cid: string;
}>(`${prefix}load-issue-calendar-info-failed`);
